var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property, query } from 'lit/decorators.js';
import styles from './DeleteButton.styles';
import '@shoelace-style/shoelace/dist/components/dialog/dialog.js';
import '../button/button.js';
import '../icon-button/icon-button.js';
import '../icon/icon.js';
import { SgdfElement } from '../../internal/sgdf-element';
export class SgdfDeleteButton extends SgdfElement {
    constructor() {
        super(...arguments);
        this.message = 'Confirmes-tu la suppression ?';
        this.danger = false;
        this.icon = false;
        this.hideButton = false;
    }
    /** Shows the dialog. */
    async show() {
        this.dialog.show();
    }
    connectedCallback() {
        super.connectedCallback();
        this.updateComplete.then(() => {
            var _a, _b, _c, _d;
            (_b = (_a = this.dialog) === null || _a === void 0 ? void 0 : _a.nextElementSibling) === null || _b === void 0 ? void 0 : _b.addEventListener('click', () => this.dialog.show());
            (_c = this.validateButton) === null || _c === void 0 ? void 0 : _c.addEventListener('click', e => {
                this.onValidate(e);
                this.dialog.hide();
            });
            (_d = this.rejectButton) === null || _d === void 0 ? void 0 : _d.addEventListener('click', () => this.dialog.hide());
        });
    }
    onValidate(event) {
        event.preventDefault();
        this.emit('sgdf-delete');
    }
    render() {
        return html `
            <sl-dialog label="Suppression" class="dialog-delete">
                <div class="message">${this.message}</div>
                <div slot="footer" class="footer">
                    <sgdf-button danger slot="validate">Oui</sgdf-button>
                    <sgdf-button slot="reject">Non</sgdf-button>
                </div>
            </sl-dialog>
            ${this.hideButton
            ? null
            : this.hasChildNodes()
                ? html `<slot></slot>`
                : this.icon
                    ? html ` <sgdf-icon-button name="trash"></sgdf-icon-button> `
                    : html `
                      <sgdf-button ?danger=${this.danger}>
                          <sgdf-icon name="trash" slot="prefix"></sgdf-icon>
                          Supprimer
                      </sgdf-button>
                  `}
        `;
    }
}
SgdfDeleteButton.styles = styles;
__decorate([
    property({ type: String })
], SgdfDeleteButton.prototype, "message", void 0);
__decorate([
    property({ type: Boolean })
], SgdfDeleteButton.prototype, "danger", void 0);
__decorate([
    property({ type: Boolean })
], SgdfDeleteButton.prototype, "icon", void 0);
__decorate([
    property({ type: Boolean })
], SgdfDeleteButton.prototype, "hideButton", void 0);
__decorate([
    query('.dialog-delete')
], SgdfDeleteButton.prototype, "dialog", void 0);
__decorate([
    query('sgdf-button[slot="validate"]')
], SgdfDeleteButton.prototype, "validateButton", void 0);
__decorate([
    query('sgdf-button[slot="reject"]')
], SgdfDeleteButton.prototype, "rejectButton", void 0);
//# sourceMappingURL=DeleteButton.js.map